import { ApiService } from "./AbstractApiService";
import { ISms } from "@/interfaces/iSms";
import { IPageModel } from "@/interfaces/iPageModel";
import API from "./handlers/base.service";
import qs from "qs";
import { iConversationCreate } from "@/interfaces/iMessage";
export class SmsAPI extends ApiService {
  public static getInstance() {
    if (!this.instance) {
      this.instance = new this();
    }
    return this.instance;
  }

  private static instance: SmsAPI | null;
  constructor() {
    super("notification");
  }
  public async getSmsList(
    params?: Record<string, string | number>
  ): Promise<IPageModel<ISms>> {
    return this.get("conversations", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public async createConversation(
    payload: iConversationCreate
  ): Promise<IPageModel<iConversationCreate>> {
    return this.post("conversations/", payload).then(
      (response) => response.data
    );
  }

  public bulkDeleteEntity(params: number[]) {
    return this.service
      .delete(`notification/conversations`, { data: params })
      .then((response) => response.data);
  }
  public bulkDeleteConversations(params: any[]) {
    return this.service
      .delete(`notification/documentConversations`, { data: params })
      .then((response) => response.data);
  }
  public resendEmail(webId: number) {
    return this.service
      .put(`email/emails/` + webId + "/resendEmail")
      .then((response) => response.data);
  }
}

export async function getEmails<T extends string>(
  url: string
): Promise<Array<Record<any, any>>> {
  return API.get(url).then((res) => {
    return res.data;
  });
}

export function convertEmailsToFilters<T extends string>(
  emails: Array<Record<any, any>>,
  key: string,
  value: string
) {
  const filters = emails?.map((item) => {
    return {
      label: item[key],
      value: item[value],
    };
  });
  return filters;
}

export async function getEmailFilters(url: string, key: string, value: string) {
  const emails = await getEmails(url);
  return convertEmailsToFilters(emails, key, value);
}
